import { TagColor } from '../../../muiComponents/Tag';

export enum CompetitorServiceStatus {
    OFFERED = 'offered',
    NOT_OFFERED = 'not_offered',
    PARITY = 'parity',
    WE_LEAD = 'we_lead',
    THEY_LEAD = 'they_lead',
}

export interface ICompetitorServiceStatusConfig {
    text: CompetitorServiceStatus;
    color: TagColor;
}
